module.exports = __webpack_public_path__ + "static/media/noah.3f6770a9.jpg";